import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { ROOT_API_URL } from '../../api-config';
import { auth } from '../../services';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router';
import domtoimage from 'dom-to-image';
import '../../scss/PublicView/receiptPDF.scss';
import { isMobile } from 'react-device-detect';

class ReceiptPDF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionId: this.props.pdfData || null,
            transaction: {
                transactionId: 0,
                aspNetUserId: null,
                createDate: "",
                grandTotal: 0,
                paymentType: "",
                name: "",
                email: "",
                subTotal: 0,
                tax: 0,
                shippingCost: 0,
                batchId: 0,
                payerName: "",
                payerAddress: "",
                transactionDetails: [],
                mobileDevice: false,
                //imgUrl: ''
            }
        };
    };

    createImage = () => {
        var node = document.getElementById('pdfExport');
        var img = new Image();
        domtoimage.toPng(node)
            .then(dataUrl => {

                //this.setState({
                //    imgUrl: dataUrl
                //});

                //if (this.state.mobileDevice) {
                //    document.getElementById('openPDF').click();
                //} else {

                    img.src = dataUrl;
                    document.getElementById('pdfImage').replaceWith(img);

                //}
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });

    }

    //openPDF = () => {
    //    this.props.cancel();
    //    if (!this.state.imgUrl) {
    //        console.log('JAYTEST DATAURL NULL!!!!!!!!!!');
    //    }
    //    var win = window.open();
    //    win.document.write('<iframe src="' + this.state.imgUrl + '" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" ></iframe>');

    //}

    pdfExportComponent;

    exportPDFWithMethod = () => {
        savePDF(document.querySelector(".pdfImage"), {
            paperSize: "auto",
            margin: 40,
            fileName: `Receipt for Transaction ${this.state.transaction.transactionId ? this.state.transaction.transactionId.toString().trim() : ""}`
        });
    };

    componentDidMount() {
        if (isMobile) {
            this.setState({
                mobileDevice: true
            });
        }

        var url = `${ROOT_API_URL}/ManageTransaction/GetTransactionDetails?transactionId=${this.state.transactionId}`;
        const options = { method: 'GET', headers: auth.authHeader() };
        axios
            .get(url, options)
            .then((res) => {
                console.log(res.data, "transaction details")
                this.setState({
                    transaction: res.data
                }, () => this.createImage())
            }).catch((err) => {
                this.props.cancel();
            })
    }

    formatAsDollar(amount) {
        var t = '$' + (Number(amount)).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return t;
    }

    render() {
        return (
            <div className="pdfContainer">
                <div style={{ position: "absolute", left: "-5000px", top: "-5000px", width: "890px" }}>
                    <PDFExport forcePageBreak=".page-break" ref={(component) => this.pdfExportComponent = component}
                        paperSize="A4"
                        scale={0.8}
                        margin=".25cm"
                    >
                        <div id="pdfExport">
                            <div className="row">
                                <div className="col-6">
                                    <img src="/images/TSCRA-Logo.png" />
                                    <p>PO Box 101988</p>
                                    <p>Fort Worth, TX 76185</p>
                                </div>
                                <div className="col-6 right">
                                    <h1>Receipt</h1>
                                    <h1 style={{ textAlign: "right" }}>Transaction #:{this.state.transaction.transactionId ? this.state.transaction.transactionId.toString().trim() : ""}</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <p>{this.state.transaction.payerName}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <p>{this.state.transaction.payerAddress}</p>
                                </div>
                            </div>

                            <div className="row headerRow rowBorderBottom">
                                <div className="col-5">
                                    <p>Description</p>
                                </div>
                                <div className="col-1">
                                    <p>Qty</p>
                                </div>
                                <div className="col-2">
                                    <p>Unit Price</p>
                                </div>
                                <div className="col-2">
                                    <p>Tax</p>
                                </div>
                                <div className="col-2 right">
                                    <p>Total</p>
                                </div>
                            </div>
                            <ul className="checkoutList rowBorderBottom">
                                {
                                    this.state.transaction.transactionDetails.map((item, index) => {
                                        if (item.productDetails !== null) {
                                            return (item.productDetails.map((product, key) => {
                                                return (
                                                    <li className="productItem" key={key}>
                                                        <div className="row">
                                                            <div className="col-5">
                                                                <p>{product.description}</p>
                                                            </div>
                                                            <div className="col-1">
                                                                <p>{product.quantity}</p>
                                                            </div>
                                                            <div className="col-2">
                                                                <p>{this.formatAsDollar(product.actualCost)}</p>
                                                            </div>
                                                            <div className="col-2">
                                                                <p>{this.formatAsDollar(product.tax)}</p>
                                                            </div>
                                                            <div className="col-2 right">
                                                                <p>{this.formatAsDollar(product.amount + product.tax)}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            )
                                        } else {
                                            return (
                                                <li className="purchaseListItem" key={index}>
                                                    <div className="row">
                                                        <div className="col-5">
                                                            <p>{item.description}</p>
                                                        </div>
                                                        <div className="col-1">
                                                            <p>{item.quantity}</p>
                                                        </div>
                                                        <div className="col-2">
                                                            <p>{this.formatAsDollar(item.actualCost)}</p>
                                                        </div>
                                                        <div className="col-2">
                                                            <p>{this.formatAsDollar(item.tax)}</p>
                                                        </div>
                                                        <div className="col-2 right">
                                                            <p>{this.formatAsDollar(item.amount + item.tax)}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        }
                                    })
                                }
                            </ul>
                            <div className="row">
                                <div className="col-6">
                                </div>
                                <div className="col-4">
                                    <h4>Sub Total</h4>
                                </div>
                                <div className="col-2 right">
                                    <h4>{this.formatAsDollar(this.state.transaction.subTotal)}</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                </div>
                                <div className="col-4">
                                    <h4>Shipping Cost</h4>
                                </div>
                                <div className="col-2 right">
                                    <h4>{this.formatAsDollar(this.state.transaction.shippingCost)}</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                </div>
                                <div className="col-4 rowBorderBottom">
                                    <h4>Sales Tax</h4>
                                </div>
                                <div className="col-2 right rowBorderBottom">
                                    <h4>{this.formatAsDollar(this.state.transaction.tax)}</h4>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-6">
                                </div>
                                <div className="col-4" style={{
                                    backgroundColor: "rgba(0, 0, 255, 0.2)"
                                }}>
                                    <h4>Total</h4>
                                </div>
                                <div className="col-2 right" style={{
                                    backgroundColor: "rgba(0, 0, 255, 0.2)"
                                }}>
                                    <h4>{this.formatAsDollar(this.state.transaction.grandTotal)}</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <h4>Paid: {this.state.transaction.paymentType} </h4>
                                </div>
                            </div>
                            <div className="row" style={{margin: "0 auto"}}>
                                <div className="col-12 text-center">
                                    <h4 >Need help?</h4>
                                    <h4>Or, do you just want to speak to someone?</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 text-center">
                                    <a href="mailto:membership@tscra.org">membership@tscra.org</a>
                                </div>
                                <div className="col-6 text-center">
                                    <a href="tel:8002427820">1-800-242-7820</a>
                                </div>
                            </div>
                        </div>
                    </PDFExport>
                </div>
                <div className="pdfImage">
                    <div id="pdfImage">
                    </div>
                </div>
                <div className="example-config">
                    {this.state.mobileDevice ?
                        ''
                        :
                        <button className="btnLink btn btn-sm btnPrimary" style={{ marginRight: "10px" }} onClick={() => {
                            this.exportPDFWithMethod();
                        }}
                        >
                            Export PDF
                        </button>
                    }
                    {
                        this.props.location.pathname !== "/payment" ?
                            <button className="btnLink btn btn-sm btnSecondary" onClick={() => {
                                this.props.cancel();
                            }}
                            >
                                CANCEL
                            </button>
                            : ""
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(ReceiptPDF);